import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { UncontrolledTooltip, Modal, ModalHeader, ModalBody, Button, FormGroup, Label, Input } from 'reactstrap';
import TickButton from '../../images/TickButton.svg';
import CrossButton from '../../images/CrossButton.svg';
import PenButton from '../../images/PenButton.svg';
import CompleteButton from '../../images/CompleteButton.svg';
import searchIcon from '../../images/SearchIcon.svg';
import RequestPaymentButton from '../../images/requestPayment.svg';
import Select from 'react-select';
import config from '../../config';
import { approveVisionOrder, cancelVisionOrder, markVisionOrderCompleted, requestPaymentFromUser, updateVisionRequest, claimVisionRequest } from '../../services/api/cashless-vision';
import OrderDetailsModal from './orderDetailsModal';
import VerifyAutoOrderModal from './VerifyAutoOrderModal';

const buttonStyle = {
  backgroundColor: '#714FFF',
  border: 'none',
  width: '112px',
  height: '32px',
  fontSize: '14px',
  fontWeight: '600',
  color: '#FFFFFF',
  alignContent: 'center'
}

const buttonStyle2 = {
  backgroundColor: '#FFFFFF',
  border: '1px solid #714FFF',
  width: '112px',
  height: '32px',
  fontSize: '14px',
  fontWeight: '600',
  color: '#714FFF',
  alignContent: 'center'
}

const VisionActions = ({
  requestId,
  getVisionRequestData,
  requestData,
  currentFilters,
}) => {
  const currentUserId = useSelector((state) => state.user.userId);
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showRequestPaymentModal, setShowRequestPaymentModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showOrderCompleteModal, setShowOrderCompleteModal] = useState(false);
  const [rejectReason, setRejectReason] = useState('');
  const [otherRejectReason, setOtherRejectReason] = useState('');
  const [loading, setLoading] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const rejectReasons = [
    'As per user request',
    'Cancelled or non-fulfilled from partner',
    'Invoice not submitted by Partner within the stipulated time',
    'Payment not completed',
    'Return and Refund from partner',
    'Vision Card not uploaded',
    'Vision card not verified',
    'Other'
  ];

  const handleClaimRequest = async () => {
    try {
      setLoading(true);
      await claimVisionRequest(requestId);
      toast.success('Request claimed successfully. You can now verify this order.');
      getVisionRequestData(currentFilters);
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to claim request');
    } finally {
      setLoading(false);
    }
  };

  const approveOrder = () => {
    setShowApproveModal(true);
  };

  const requestPayment = () => {
    setShowRequestPaymentModal(true);
  };

  const toggleEditOrderModal = () => {
    setShowEditModal(!showEditModal);
  };
  
  const handleEditOrderDetails = async (requestId, orderDetails) => {
    try {
      const response = await updateVisionRequest(requestId, orderDetails);

      if (response.message === 'success') {
        setShowEditModal(false);
        getVisionRequestData(currentFilters);
      }
      return response;
    } catch (error) {
      throw error;
    }
  };

  const handleApproveConfirm = async () => {
    try {
      setLoading(true);
      await approveVisionOrder(requestId);
      toast.success('Order approved successfully');
      setShowApproveModal(false);
      console.log(currentFilters, 'currentFilters');
      getVisionRequestData(currentFilters);
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to approve order');
    } finally {
      setLoading(false);
    }
  };

  const handleRequestPayment = async () => {
    try {
      setLoading(true);
      await requestPaymentFromUser(requestId);
      toast.success('Payment requested successfully');
      setShowRequestPaymentModal(false);
      getVisionRequestData(currentFilters);
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to request payment for this order');
    } finally {
      setLoading(false);
    }
  };

  const rejectOrder = () => {
    setShowRejectModal(true);
  };

  const handleRejectConfirm = async () => {
    if (!rejectReason || (rejectReason === 'Other' && !otherRejectReason)) {
      toast.error('Please select a reason for rejection');
      return;
    }

    try {
      setLoading(true);
      const finalReason = rejectReason === 'Other' ? otherRejectReason : rejectReason;
      await cancelVisionOrder(requestId, finalReason);
      toast.success('Order rejected successfully');
      setShowRejectModal(false);
      setRejectReason('');
      setOtherRejectReason('');
      getVisionRequestData(currentFilters);
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to reject order');
    } finally {
      setLoading(false);
    }
  };

  const editOrder = () => {
    setShowEditModal(true);
  };

  const markOrderCompleted = () => {
    setShowOrderCompleteModal(true);
  };

  const handleMarkOrderCompleted = async () => {
    try {
      setLoading(true);
      await markVisionOrderCompleted(requestId);
      toast.success('Order completed marked successfully');
      setShowOrderCompleteModal(false);
      getVisionRequestData(currentFilters);
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to mark order completed');
    } finally {
      setLoading(false);
    }
  };
  

  const redirectToKea = (journeyType) => {
    window.open(`${config.keaAppUrl}?requestId=${requestData.requestId}&journey=${journeyType}`, '_blank');
  };

  const visibleActions = [];
  const isTitanPartner = parseInt(requestData.partnerId) === 5;

  if (requestData.isOrderAutoCreated && !requestData.opsVerified) {
    const isAssignedOps = requestData.opsUserId === currentUserId;
    if (isAssignedOps) {
      visibleActions.push('verifyOrder');
    } else {
      visibleActions.push('claimRequest');
    }
    visibleActions.push('rejectOrder');
  } else if (isTitanPartner) {
    visibleActions.push('rejectOrder', 'editOrder');
  } else if (requestData.isOfflineStorePartner) {
    if (!requestData.invoiceUploaded || requestData.requestStatus === 'document-rejected') {
      visibleActions.push('rejectOrder');
      visibleActions.push('upload');
      visibleActions.push('kiaLink');
      visibleActions.push('editOrder');
    } else if (requestData.preAuthCount === 0) {
      visibleActions.push('rejectOrder');
      visibleActions.push('addItem');
      visibleActions.push('kiaLink');
      visibleActions.push('editOrder');
    } else {
      visibleActions.push('markOrderCompleted', 'rejectOrder', 'editOrder', 'kiaLink');
    }
  } else {
    visibleActions.push('approveOrder', 'rejectOrder', 'requestPayment', 'editOrder', 'markOrderCompleted');
  }

  return (
    <>
      <div className="d-flex flex-row justify-center" style={{ gap: '8px' }}>
        {visibleActions.includes('verifyOrder') && (
          <div>
            <UncontrolledTooltip target={`verifyButton-${requestId}`}>
              Verify Auto-Created Order
            </UncontrolledTooltip>
            <Button
              id={`verifyButton-${requestId}`}
              onClick={() => setShowVerifyModal(true)}
              style={{
                backgroundColor: '#6C5DD3',
                border: 'none',
                width: '80px',
                height: '32px',
                fontSize: '13px',
                fontWeight: '600',
                color: '#FFFFFF',
              }}
            >
              Verify
            </Button>
          </div>
        )}
        {visibleActions.includes('claimRequest') && (
          <div>
            <UncontrolledTooltip target={`claimButton-${requestId}`}>
              Claim this request to verify it
            </UncontrolledTooltip>
            <Button
              id={`claimButton-${requestId}`}
              onClick={handleClaimRequest}
              disabled={loading}
              style={{
                backgroundColor: '#FFFFFF',
                border: '1px solid #6C5DD3',
                color: '#6C5DD3',
                width: '80px',
                height: '32px',
                fontSize: '13px',
                fontWeight: '600',
              }}
            >
              {loading ? '...' : 'Claim'}
            </Button>
          </div>
        )}
        {visibleActions.includes('upload') && (
          <div className="d-flex flex-row justify-center" style={{ gap: '8px' }}>
            <Button
              onClick={() => redirectToKea('upload')}
              style={buttonStyle}
            >
              + Upload
            </Button>
          </div>
        )}
        {visibleActions.includes('addItem') && (
          <div className="d-flex flex-row justify-center" style={{ gap: '8px' }}>
            <Button
              onClick={() => redirectToKea('addItem')}
              style={buttonStyle2}
            >
              + Add Item
            </Button>
          </div>
        )}
        {visibleActions.includes('approveOrder') && (
          <div>
            <UncontrolledTooltip target={`approveButton-${requestId}`}>
              Approve Order
            </UncontrolledTooltip>
            <img
              src={TickButton}
              alt="Approve"
              className="button-img"
              style={{
                width: '24px',
                height: '24px',
                cursor: 'pointer'
              }}
              id={`approveButton-${requestId}`}
              onClick={approveOrder}
            />
          </div>
        )}
        {visibleActions.includes('rejectOrder') && (
          <div>
            <UncontrolledTooltip target={`rejectButton-${requestId}`}>
              Reject Order
            </UncontrolledTooltip>
            <img
              id={`rejectButton-${requestId}`}
              onClick={rejectOrder}
              src={CrossButton}
              alt="Reject"
              className="button-img"
              style={{
                width: '24px',
                height: '24px',
                cursor: 'pointer'
              }}
            />
          </div>
        )}
        {visibleActions.includes('requestPayment') && (
          <div>
            <UncontrolledTooltip target={`requestPaymentButton-${requestId}`}>
              Request Payment
            </UncontrolledTooltip>
            <img
              src={RequestPaymentButton}
              alt="Request Payment"
              className="button-img"
              id={`requestPaymentButton-${requestId}`}
              onClick={requestPayment}
              style={{
                width: '24px',
                height: '24px',
                cursor: 'pointer'
              }}
            />
          </div>
        )}
        {visibleActions.includes('editOrder') && (
          <div>
            <UncontrolledTooltip target={`editButton-${requestId}`}>
              {isTitanPartner ? 'View Order Details' : 'Edit Order'}
            </UncontrolledTooltip>
            <img
              src={PenButton}
              alt="Edit"
              className="button-img"
              id={`editButton-${requestId}`}
              onClick={editOrder}
              style={{
                width: '24px',
                height: '24px',
                cursor: 'pointer',
                opacity: 1,
              }}
            />
          </div>
        )}
        {visibleActions.includes('markOrderCompleted') && (
          <div>
            <UncontrolledTooltip target={`completeButton-${requestId}`}>
              Mark Order Completed
            </UncontrolledTooltip>
            <img
              src={CompleteButton}
              alt="Mark Order Completed"
              className="button-img"
              id={`completeButton-${requestId}`}
              onClick={markOrderCompleted}
              style={{
                width: '24px',
                height: '24px',
                cursor: 'pointer'
              }}
            />
          </div>
        )}
        {visibleActions.includes('kiaLink') && (
          <div>
            <UncontrolledTooltip target={`kiaLink-${requestId}`}>
              Kea Link
            </UncontrolledTooltip>
            <img
              src={searchIcon}
              alt="Kia Link"
              className="button-img"
              id={`kiaLink-${requestId}`}
              onClick={() => redirectToKea()}
              style={{
                width: '24px',
                height: '24px',
                cursor: 'pointer'
              }}
            />
          </div>
        )}
      </div>

      {/* Verify Auto Order Modal */}
      {showVerifyModal && (
        <VerifyAutoOrderModal
          isOpen={showVerifyModal}
          toggle={() => setShowVerifyModal(false)}
          requestId={requestId}
          onVerified={() => {
            setShowVerifyModal(false);
            getVisionRequestData(currentFilters);
          }}
        />
      )}

      {/* Approve Confirmation Modal */}
      <Modal isOpen={showApproveModal} toggle={() => setShowApproveModal(false)} centered>
        <ModalHeader toggle={() => setShowApproveModal(false)}>
          Confirm Approval
        </ModalHeader>
        <ModalBody>
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            Are you sure you want to approve this order?
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
            <Button
              onClick={handleApproveConfirm}
              disabled={loading}
              style={{
                backgroundColor: '#714FFF',
                border: 'none',
                width: '100px'
              }}
            >
              {loading ? 'Processing...' : 'Yes'}
            </Button>
            <Button
              onClick={() => setShowApproveModal(false)}
              style={{
                backgroundColor: '#FFFFFF',
                border: '1px solid #714FFF',
                color: '#714FFF',
                width: '100px'
              }}
            >
              No
            </Button>
          </div>
        </ModalBody>
      </Modal>

      {/* Reject Confirmation Modal */}
      <Modal isOpen={showRejectModal} toggle={() => setShowRejectModal(false)} centered>
        <ModalHeader toggle={() => setShowRejectModal(false)}>
          Reject Order
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Select Reason for Rejection</Label>
            <Select
              options={rejectReasons.map(reason => ({ value: reason, label: reason }))}
              value={{ value: rejectReason, label: rejectReason }}
              onChange={(selected) => setRejectReason(selected.value)}
              placeholder="Select a reason"
            />
            {rejectReason === 'Other' && (
              <Input
                type="textarea"
                value={otherRejectReason}
                onChange={(e) => setOtherRejectReason(e.target.value)}
                placeholder="Please specify the reason"
                style={{ marginTop: '10px' }}
              />
            )}
          </FormGroup>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '20px' }}>
            <Button
              onClick={handleRejectConfirm}
              disabled={loading || !rejectReason || (rejectReason === 'Other' && !otherRejectReason)}
              style={{
                backgroundColor: '#714FFF',
                border: 'none',
                width: '100px'
              }}
            >
              {loading ? 'Processing...' : 'Confirm'}
            </Button>
            <Button
              onClick={() => {
                setShowRejectModal(false);
                setRejectReason('');
                setOtherRejectReason('');
              }}
              style={{
                backgroundColor: '#FFFFFF',
                border: '1px solid #714FFF',
                color: '#714FFF',
                width: '100px'
              }}
            >
              Cancel
            </Button>
          </div>
        </ModalBody>
      </Modal>

      {/* Mark Order Completed Modal */}
      <Modal isOpen={showOrderCompleteModal} toggle={() => setShowOrderCompleteModal(false)} centered>
        <ModalHeader toggle={() => setShowOrderCompleteModal(false)}>
          Mark Order Completed
        </ModalHeader>
        <ModalBody>
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            Are you sure you want to mark this order completed?
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
            <Button
              onClick={handleMarkOrderCompleted}
              disabled={loading}
              style={{
                backgroundColor: '#714FFF',
                border: 'none',
                width: '100px'
              }}
            >
              {loading ? 'Processing...' : 'Yes'}
            </Button>
            <Button
              onClick={() => setShowOrderCompleteModal(false)}
              style={{
                backgroundColor: '#FFFFFF',
                border: '1px solid #714FFF',
                color: '#714FFF',
                width: '100px'
              }}
            >
              No
            </Button>
          </div>
        </ModalBody>
      </Modal>

      {/* Edit Vision Request Modal */}
      {showEditModal && (
        <OrderDetailsModal
          isOpen={showEditModal}
          toggle={toggleEditOrderModal}
          onSubmit={handleEditOrderDetails}
          requestId={requestId}
          ModalHeader={isTitanPartner ? 'View Order Details' : 'Edit Order Details'}
        />
      )}

      {/* Collect Payment Modal */}
      <Modal isOpen={showRequestPaymentModal} toggle={() => setShowRequestPaymentModal(false)} centered>
        <ModalHeader toggle={() => setShowRequestPaymentModal(false)}>
          Request Payment
        </ModalHeader>
        <ModalBody>
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            Are you sure you want to request payment for this order?
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
            <Button
              onClick={handleRequestPayment}
              disabled={loading}
              style={{
                backgroundColor: '#714FFF',
                border: 'none',
                width: '100px'
              }}
            >
              {loading ? 'Processing...' : 'Yes'}
            </Button>
            <Button
              onClick={() => setShowRequestPaymentModal(false)}
              style={{
                backgroundColor: '#FFFFFF',
                border: '1px solid #714FFF',
                color: '#714FFF',
                width: '100px'
              }}
            >
              No
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default VisionActions;
